import React from 'react';
import { reset } from 'redux-form';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { required } from 'redux-form-validators';
import { toPlainObject, toArray, filter, isEmpty } from 'lodash';

import { MODAL_TYPE_PAYMENT_REQUEST_EBON_UNAVAILABLE } from '../../../../services/modal/constants';

import {
    fetcheBonsByPartnerId,
    lockEbons,
    resetLock,
    createOrder,
    resetCart
} from '../../../../services/ebon/actions';
import { showModal } from '../../../../services/modal/actions';
import { sendPaymentEbonRequest } from '../../../../services/account/paymentrequest/request/actions';

import { mergeQueryLocked } from '../../../../utils/ebonUtils';
import { getMerchantCardUrl } from '../../../../services/partner/utils';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import { getValidatedAmount } from '../../../../services/account/gains/selector';
import * as paymentRequestSelector from '../../../../services/account/paymentrequest/request/selector';

import {
    CheckboxInputFieldComponent,
    EmailInputFieldComponent,
    FormComponent,
    LegendFieldComponent,
    SelectFieldComponent
} from '../../../form';
import { LoadingComponent } from '../../../loading/LoadingComponent';
import PaymentRequestEbonSelectorComponent from './PaymentRequestEbonSelectorComponent';

import './PaymentRequestEbonFormComponent.scss';

const DUMMY_FORM = 'dummy-form';
const FORM_NAME = 'paymentrequest-form';

const getPartnersOptions = (data = []) => data.map(item => ({ label: item.name, value: item.id }));

const mapUserCart = (cart, partners) => {
    if (cart.length > 0) {
        const partner = filter(partners, p => p.id === cart[0].partnerId)[0];
        return cart.map(item => {
            return {
                quantity: item.quantityQuery,
                partnerName: partner.name,
                value: item.facialValue
            };
        });
    }
    return [];
};

class PaymentRequestEbonFormComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedPartnerId: -1,
            email: '',
            requestedAmount: 0,
            cappingError: false
        };
    }

    componentDidMount() {
        this.scrollTop();
    }

    componentDidUpdate(prevProps) {
        const {
            validatedCashbackAmount,
            createOrder,
            sendPaymentEbonRequest,
            reset,
            ebonCart,
            ebonLock,
            lockFailure,
            createdOrder,
            resetCart
        } = this.props;
        const { selectedPartnerId, email, requestedAmount } = this.state;

        if (ebonLock !== prevProps.ebonLock) {
            if (!isEmpty(ebonLock)) {
                const { allLocked } = ebonLock;
                if (!allLocked) {
                    delete ebonLock.allLocked;
                    const final = mergeQueryLocked(ebonCart, ebonLock);
                    this.showModal({
                        data: final,
                        partner: this.getEbonPartner()
                    });
                }
                createOrder(selectedPartnerId, null, null);
            }
        }
        if (lockFailure !== prevProps.lockFailure && lockFailure) {
            if (lockFailure.statusCode === 406) {
                this.setState({ cappingError: true });
            }
        }

        if (createdOrder && createdOrder !== prevProps.createdOrder) {
            if (requestedAmount > 0 && requestedAmount <= validatedCashbackAmount) {
                sendPaymentEbonRequest(
                    { email: email, requestedAmount: requestedAmount, orderId: createdOrder.id },
                    () => {
                        resetCart();
                        reset(FORM_NAME);
                        this.scrollTop();
                    }
                );
            }
        }
    }

    showModal = props =>
        this.props.showModal(MODAL_TYPE_PAYMENT_REQUEST_EBON_UNAVAILABLE, { ...props });

    scrollTop = () => {
        if (document.getElementById('paymentAreaAnchor')) {
            document.getElementById('paymentAreaAnchor').scrollIntoView({ behavior: 'smooth' });
        }
    };

    toMerchantCardUrl = urlParams => {
        const { history, resetLock } = this.props;

        resetLock();

        const partner = this.getEbonPartner();
        const merchantCardPath = getMerchantCardUrl(
            { id: partner.id, name: partner.name },
            false,
            true
        );
        const url = `${merchantCardPath}${urlParams ? urlParams : ''}`;

        history.push(url);
    };

    submit = formData => {
        const { lockEbons, ebonCart, userCart, user } = this.props;
        const { selectedPartnerId } = this.state;

        const cartAmount = userCart.reduce(
            (previousValue, currentValue) =>
                previousValue + currentValue.quantity * currentValue.value,
            0
        );
        this.setState({ email: formData.email, requestedAmount: cartAmount });

        const ebonCartBody = {
            lockRequests: ebonCart,
            userId: user.username,
            partnerId: selectedPartnerId,
            fixedFacialValue: true
        };

        lockEbons(ebonCartBody, null);
    };

    handleOnChangePartner = e => {
        const { fetcheBonsByPartnerId, resetCart, resetLock } = this.props;

        resetLock();
        resetCart();
        this.setState({ cappingError: false });

        const value = Number(e.target.value);
        if (value > 0) {
            this.setState({ selectedPartnerId: value });
            fetcheBonsByPartnerId(value);
        } else {
            this.setState({ selectedPartnerId: -1 });
        }
    };

    getEbonPartner = () => {
        const { ebonPartners } = this.props;
        const { selectedPartnerId } = this.state;
        const ebonPartner = ebonPartners.filter(p => p.id === selectedPartnerId);

        return ebonPartner.length > 0 ? ebonPartner[0] : null;
    };

    render() {
        const {
            i18n,
            i18nCommon,
            errorSubmit,
            errorMessage,
            requestSubmit,
            initialValues,
            validatedCashbackAmount,
            partnersOption,
            ebons,
            ebonsFetching,
            ebonPartnersFetching,
            userCart,
            lockFetching,
            createOrderRequest
        } = this.props;
        const { selectedPartnerId, cappingError } = this.state;

        const cartAmount = userCart.reduce(
            (previousValue, currentValue) =>
                previousValue + currentValue.quantity * currentValue.value,
            0
        );
        const remainingJackpotAfterPayment = validatedCashbackAmount - cartAmount;

        return (
            <React.Fragment>
                <FormComponent
                    form={DUMMY_FORM}
                    classNameInputContainer="payment-request-dummy-form"
                    onSubmit={null}
                    hideButton>
                    {ebonPartnersFetching ? (
                        <p className="partnerLoading">
                            <LoadingComponent />
                        </p>
                    ) : (
                        <SelectFieldComponent
                            name="partnerId"
                            label={i18n.PAYMENT_REQUEST_FORM.LABEL_PARTNER}
                            defaultOptionLabel={
                                i18n.PAYMENT_REQUEST_FORM.DEFAULT_OPTION_LABEL_PARTNER
                            }
                            classNameInputContainer="one-half mr50"
                            isRequired
                            options={partnersOption}
                            validate={[required({ msg: i18nCommon.REQUIRED })]}
                            onChange={this.handleOnChangePartner}
                        />
                    )}

                    {ebonsFetching && (
                        <p className="partnerLoading">
                            <LoadingComponent />
                        </p>
                    )}
                    {selectedPartnerId &&
                        this.getEbonPartner() &&
                        ebons &&
                        ebons.ebonDiscount &&
                        !ebonsFetching && (
                            <React.Fragment>
                                <PaymentRequestEbonSelectorComponent
                                    ebons={ebons}
                                    partner={this.getEbonPartner()}
                                    validatedCashbackAmount={validatedCashbackAmount}
                                />

                                <LegendFieldComponent>
                                    {convertHtmlToReactDomWithParams(
                                        i18n.PAYMENT_REQUEST_FORM
                                            .REMAINING_JACKPOT_AFTER_EBON_PAYMENT_INDICATION,
                                        this.getEbonPartner().name,
                                        cartAmount.toFixed(2).replace('.', ','),
                                        remainingJackpotAfterPayment.toFixed(2).replace('.', ',')
                                    )}
                                </LegendFieldComponent>
                            </React.Fragment>
                        )}
                </FormComponent>

                {selectedPartnerId &&
                    this.getEbonPartner() &&
                    ebons &&
                    ebons.ebonDiscount &&
                    !ebonsFetching && (
                        <FormComponent
                            form={FORM_NAME}
                            initialValues={initialValues}
                            classNameInputContainer="payment-request-ebon-form"
                            onSubmit={this.submit}
                            requestSubmit={lockFetching || requestSubmit || createOrderRequest}
                            errorSubmit={errorSubmit}
                            submitText={i18n.PAYMENT_REQUEST_FORM.PAYMENT_REQUEST_EBONS_BUTTON}
                            buttonDisabled={cartAmount <= 0 || remainingJackpotAfterPayment < 0}>
                            <EmailInputFieldComponent
                                name="email"
                                label={i18n.PAYMENT_REQUEST_FORM.EMAIL_ADDRESS_CONFIRMATION}
                                placeholder={i18nCommon.PLACEHOLDER_EMAIL}
                                classNameInputContainer="one-half mr50"
                                isRequired
                            />

                            <CheckboxInputFieldComponent
                                name="confirmEmail"
                                classNameInputContainer="confirmEmail"
                                options={[
                                    {
                                        label:
                                            i18n.PAYMENT_REQUEST_FORM
                                                .EMAIL_DELIVERY_VALIDATION_CHECKBOX_LABEL_EBON,
                                        value: true
                                    }
                                ]}
                                minRequired={1}
                            />

                            <LegendFieldComponent classNameInputContainer="full">
                                {i18nCommon.MANDATORY_FIELD}
                            </LegendFieldComponent>

                            {errorMessage && (
                                <LegendFieldComponent classNameInputContainer="color-err">
                                    {errorMessage}
                                </LegendFieldComponent>
                            )}
                            {cappingError && (
                                <p className="error-message">
                                    {convertHtmlToReactDomWithParams(
                                        i18n.PAYMENT_REQUEST_FORM.CAPPING_ERROR_MESSAGE_1
                                    )}
                                    <span
                                        className="fakeLink"
                                        onClick={() => this.toMerchantCardUrl('#conditions')}>
                                        {i18n.PAYMENT_REQUEST_FORM.CAPPING_ERROR_MESSAGE_2}
                                    </span>
                                    {i18n.PAYMENT_REQUEST_FORM.CAPPING_ERROR_MESSAGE_3}
                                </p>
                            )}
                        </FormComponent>
                    )}
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = {
    sendPaymentEbonRequest,
    reset,
    fetcheBonsByPartnerId,
    lockEbons,
    resetLock,
    createOrder,
    resetCart,
    showModal
};

const mapStoreToProps = state => {
    const user = toPlainObject(state.account.user);

    return {
        requestSubmit: paymentRequestSelector.isRequesting(state),
        errorSubmit: paymentRequestSelector.isError(state),
        errorMessage: paymentRequestSelector.getError(state),
        successSubmit: paymentRequestSelector.isSuccess(state),
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT,
        i18nCommon: state.i18n.feature.form,
        validatedCashbackAmount: getValidatedAmount(state),
        initialValues: {
            email: user.email ? user.email : '',
            partnerId: toArray(state.partner.partners[0])
        },
        ebons: state.ebon.ebons,
        ebonsFetching: state.ebon.ebonsFetching,
        ebonPartners: state.ebon.ebonPartners,
        ebonPartnersFetching: state.ebon.ebonPartnersFetching,
        partnersOption: getPartnersOptions(toArray(state.ebon.ebonPartners)),
        ebonCart: state.ebon.cart,
        userCart: mapUserCart(state.ebon.cart, state.ebon.ebonPartners),
        ebonLock: state.ebon.lock,
        lockFetching: state.ebon.lockFetching,
        lockFailure: state.ebon.lockFailure,
        createOrderRequest: state.ebon.createOrderRequest,
        createdOrder: state.ebon.createdOrder,
        user: user
    };
};

export default withRouter(
    connect(mapStoreToProps, mapDispatchToProps)(PaymentRequestEbonFormComponent)
);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/PaymentRequestEbonFormComponent.js